import React from 'react';
const MyContext = React.createContext({
    Token: "W4lyaidIGicUCR1gCtaC2JEbn4D2AvzyRwRAHCCcUjvWOx6Epe",
endPointUrl: process.env.REACT_APP_API_URL,
    updatetoken: () => { },
    user: null,
    updateUser: () => { },
});
export default MyContext;   